/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CopyToThreediModel
 */
export interface CopyToThreediModel {
  /**
   *
   */
  threedimodel: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  tags?: Array<any>;
  /**
   *
   */
  cloneEvents?: boolean;
  /**
   *
   */
  cloneInitials?: boolean;
  /**
   *
   */
  cloneSettings?: boolean;
}

/**
 * Check if a given object implements the CopyToThreediModel interface.
 */
export function instanceOfCopyToThreediModel(value: object): value is CopyToThreediModel {
  if (!("threedimodel" in value) || value["threedimodel"] === undefined) return false;
  return true;
}

export function CopyToThreediModelFromJSON(json: any): CopyToThreediModel {
  return CopyToThreediModelFromJSONTyped(json, false);
}

export function CopyToThreediModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CopyToThreediModel {
  if (json == null) {
    return json;
  }
  return {
    threedimodel: json["threedimodel"],
    name: json["name"] == null ? undefined : json["name"],
    tags: json["tags"] == null ? undefined : json["tags"],
    cloneEvents: json["clone_events"] == null ? undefined : json["clone_events"],
    cloneInitials: json["clone_initials"] == null ? undefined : json["clone_initials"],
    cloneSettings: json["clone_settings"] == null ? undefined : json["clone_settings"],
  };
}

export function CopyToThreediModelToJSON(json: any): CopyToThreediModel {
  return CopyToThreediModelToJSONTyped(json, false);
}

export function CopyToThreediModelToJSONTyped(
  value?: CopyToThreediModel | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    threedimodel: value["threedimodel"],
    name: value["name"],
    tags: value["tags"],
    clone_events: value["cloneEvents"],
    clone_initials: value["cloneInitials"],
    clone_settings: value["cloneSettings"],
  };
}
